export const mantineSizes = ["xs", "sm", "md", "lg", "xl"];
export const defaultMantineTransitionDuration = 250;

export const defaultMantineModalZIndex = 200;
